import BroadcastUserInfo from "./BroadcastUserInfo";

export default class HeaderUser
{
    constructor ()
    {
        let bui = new BroadcastUserInfo();
        bui.addListener ( (event) =>
                          {
                              const data = event.data;

                              if ("name" in data)
                              {
                                  let name = document.querySelector(".header-user-name");

                                  if (name)
                                  {
                                      name.innerText = data.name;
                                  }
                              }
                          })
    }
}
